import { Expose } from "class-transformer";

export class UnassignPlanningBoardUserDto {
  @Expose()
  planningBoardProjectId: string;

  @Expose()
  userId: string;
}
